import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {BaseComponent, ClassificatorValuesQuery, GLOBAL, Guid, LeModalService} from "common-shared";
import {PropertyService} from "web-shared";
import {IntegratedMasterService} from "../services/integrated-master.service";
import {ItemService} from "../../../common/item/item.service";
import {ImeConfig} from "../ime-config";
import {MasterInputInstructionModel} from "web-shared";
import {MasterOperationModel} from "web-shared";
import {TaskSelectorModel} from "web-shared";
import {SpecLineModel} from "web-shared";
import {TaskSelectorEditModalComponent} from "../task-selector-edit-modal/task-selector-edit-modal.component";
import {filter, takeUntil} from "rxjs/operators";
import {ManufacturingItemGroupService} from "../../manufactured-item-groups/manufacturing-item-group.service";
import {ManufacturingItemGroupEditModalComponent} from "../../manufactured-item-groups/manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component";
import {ManufacturingItemEditModalComponent} from "../../manufacturing-item/manufacturing-item-edit-modal/manufacturing-item-edit-modal.component";
import {CopyPasteService} from "web-shared";
import {IImeFeatures} from "web-shared";
import {instanceToInstance} from "class-transformer";
import {MasterInputInstructionEditModalComponent} from "../master-input-instruction-edit-modal/master-input-instruction-edit-modal.component";

@Component({
  selector: '[mes-master-input-instruction-edit]',
  templateUrl: './master-input-instruction-edit.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class MasterInputInstructionEditComponent extends BaseComponent implements OnInit {
  @Input() masterInputInstruction: MasterInputInstructionModel;
  @Input() masterOperation: MasterOperationModel;
  @Input() index: number;
  @Input() nrOfInstructionsInTaskSelector: number;
  @Input() taskSelector: TaskSelectorModel;
  @Input() settings: IImeFeatures;
  @Input() readonly: boolean = false;
  @Input() isAlternative: boolean = false;
  @Input() isManufacturingItem: boolean = false;
  @Input() allowItemGroupsAsInputs: boolean = false;
  @Output() onShowIme = new EventEmitter<MasterInputInstructionModel>();
  @Output() changed = new EventEmitter<MasterInputInstructionModel>();
  hasAnyAction: boolean = true;

  constructor(public classificatorValuesQuery: ClassificatorValuesQuery, public integratedMasterService: IntegratedMasterService, public propertyService: PropertyService, public itemService: ItemService, public imeConfig: ImeConfig, private modalService: LeModalService, public itemGroupService: ManufacturingItemGroupService, public copyPasteService: CopyPasteService) {
    super();
  }

  ngOnInit() {
    this.itemService.get$(this.masterInputInstruction.ItemId).subscribe(value => {
      if (value) {
        const hasIme = value.ItemTypeClv !== GLOBAL.Classificators.ItemType.RawMaterial;
        this.hasAnyAction = !this.readonly || hasIme;
      }
    });
  }

  showIme() {
    this.onShowIme.emit(this.masterInputInstruction);
  }

  setSpecs(masterInputInstruction: MasterInputInstructionModel, $event: SpecLineModel[]) {
    masterInputInstruction.Specs = [...$event];
  }

  addNewTaskSelector() {
    this.modalService.show(TaskSelectorEditModalComponent, {initialState: {taskSelector: new TaskSelectorModel({Id: Guid.create()}), mode: "add"}, class: 'modal-xl'})
      .onHide$.pipe(filter(value => value?.data !== null), takeUntil(this.componentDestroyed)).subscribe(value => {
      this.masterOperation.TaskSelectors = this.masterOperation.TaskSelectors ? [...this.masterOperation.TaskSelectors, value.data] : [value.data];
      this.changeSelector(value.data);
      this.changed.emit();
      return value.data;
    });
  }

  changeSelector(ts: TaskSelectorModel) {
    this.masterInputInstruction.TaskSelectorId = this.masterInputInstruction.TaskSelectorId === ts.Id ? undefined : ts.Id;
    this.masterOperation.MasterInputInstructions = [...this.masterOperation.MasterInputInstructions];
    this.changed.emit();
  }

  paste(masterOperation: MasterOperationModel, fromClipboard: boolean = false) {
    this.copyPasteService.paste('MasterInstruction', masterOperation, null, this.taskSelector, fromClipboard).then(() => {
      this.changed.emit();
    });
  }

  openItemEditModal(itemId: string) {
    this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityId: itemId}, class: 'modal-xl'});
  }

  openItemGroupEditModal(itemGroupId: string) {
    this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityId: itemGroupId}, class: 'modal-xl'});
  }

  edit() {
    this.modalService.show(MasterInputInstructionEditModalComponent, {initialState: {masterInstruction: this.masterInputInstruction, masterOperation: this.masterOperation, readonly: this.readonly}, class: 'modal-xl'})
      .onHide$.pipe(filter(value => value?.data !== null), takeUntil(this.componentDestroyed)).subscribe(() => {
      this.masterInputInstruction = instanceToInstance(this.masterInputInstruction);
      this.changed.emit();
    });
  }
}
